import data from './config.json';

class ConfigSingleton {
    static instance;
    config = data;
    isSingletonUpdated = false;
    updateConfigChange = () => {}; // callback to notify config update

    constructor() {
        if (ConfigSingleton.instance) {
            return ConfigSingleton.instance;
        }

        ConfigSingleton.instance = this;
    }

    static getInstance() {
        if (!ConfigSingleton.instance) {
            ConfigSingleton.instance = new ConfigSingleton();
        }

        return ConfigSingleton.instance;
    }

    getConfig() {
        return this.config;
    }

    updateConfig(newConfig) {
        this.config = newConfig;
        this.isSingletonUpdated = true;
        this.updateConfigChange();
    }
}

const configInstance = ConfigSingleton.getInstance();

export default configInstance;
